// extracted by css-extract-rspack-plugin
export default {"wrapper":"Findings-module__wrapper__h9wEi"};